import { render, staticRenderFns } from "./OrderAddress.vue?vue&type=template&id=1ed425ee&scoped=true&"
import script from "./OrderAddress.vue?vue&type=script&lang=js&"
export * from "./OrderAddress.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddress.vue?vue&type=style&index=0&id=1ed425ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed425ee",
  null
  
)

export default component.exports